import {useSignal} from '@preact/signals-react'
import {useSignals} from '@preact/signals-react/runtime'
import {Button} from 'primereact/button'
import {Dialog} from 'primereact/dialog'
import {InputText} from 'primereact/inputtext'
import {Password} from 'primereact/password'
import {forwardRef, useImperativeHandle} from 'react'
import TranslateUtils from '../../i18n/TranslateUtils'
import {
    blockOverflownScroll,
    unblockOverflownScroll,
} from '../../utils/BlockScrollsUtils'

export const WatchNetworkForm = forwardRef(({onAddNetwork = () => {}}, ref) => {
    useSignals()
    useImperativeHandle(ref, () => ({
        showForm: handleShowForm,
        hideForm: handleHideForm,
    }))

    //#region Translate
    const {translateCommons, translateKeys} = TranslateUtils()
    //#endregion

    //#region State
    const data = useSignal({
        ssid: '',
        passphrase: '',
    })
    const visible = useSignal(false)
    //#endregion

    //#region Handle Function
    const handleShowForm = value => {
        blockOverflownScroll()
        visible.value = true
        data.value = {
            ...data.value,
            ...value,
        }
    }
    const handleHideForm = () => {
        unblockOverflownScroll()
        visible.value = false
        data.value = {
            ssid: '',
            passphrase: '',
        }
    }

    const handleSubmit = () => {
        if (onAddNetwork && typeof onAddNetwork === 'function') {
            onAddNetwork(data.value)
        }
    }
    //#endregion

    return (
        <div>
            <Dialog
                header={
                    <h5 className=" mb-0 font-bold">
                        <strong>{translateKeys('Add a Network')}</strong>
                    </h5>
                }
                style={{width: '40vw'}}
                breakpoints={{'960px': '75vw', '641px': '100vw'}}
                visible={visible.value}
                onHide={handleHideForm}>
                <div className="my-3">
                    <div className="col-12 mb-3 px-0">
                        <div className="col-12 mb-3">
                            <h5 className="font-bold mb-1">
                                {translateKeys('SSID')}
                            </h5>
                            <div className="mb-3">
                                <label>
                                    {translateCommons(
                                        'Please enter the SSID of the network as the name of the network. For example',
                                    )}
                                    ,{' '}
                                    <span>
                                        <strong>"MyNetwork 5Ghz"</strong>
                                    </span>
                                </label>
                            </div>
                            <InputText
                                className="font-bold col-12 h-3rem"
                                value={data.value.ssid || ''}
                                onChange={e =>
                                    (data.value = {
                                        ...data.value,
                                        ssid: e.target.value,
                                    })
                                }
                                placeholder={translateCommons('Input SSID')}
                            />
                        </div>
                        <div className="col-12 mb-3">
                            <h5 className="font-bold mb-1">
                                {translateKeys('Passphrase')}
                            </h5>
                            <div className="mb-3">
                                <label>
                                    {translateCommons(
                                        'Please enter the passphrase of the network. For example',
                                    )}
                                    ,{' '}
                                    <span>
                                        <strong>"MyNetworkPassword"</strong>
                                    </span>
                                </label>
                            </div>
                            <Password
                                inputId="password"
                                toggleMask
                                inputClassName="col-12 h-3rem font-semibold"
                                className="col-12 px-0"
                                value={data.value.passphrase || ''}
                                onChange={e =>
                                    (data.value = {
                                        ...data.value,
                                        passphrase: e.target.value,
                                    })
                                }
                                placeholder={translateCommons(
                                    'Input passphrase',
                                )}
                            />
                        </div>
                    </div>
                    <div>
                        <Button
                            className="col-12 p-button-lg"
                            label={translateCommons('SUBMIT')}
                            icon="pi pi-send"
                            onClick={() => handleSubmit()}
                        />
                    </div>
                    <div className="mt-3">
                        <Button
                            className="col-12 p-button-lg p-button-text"
                            label={translateCommons('CLOSE')}
                            icon="pi pi-times"
                            onClick={() => handleHideForm()}
                        />
                    </div>
                </div>
            </Dialog>
        </div>
    )
})
